import React from 'react';
import { useNetworkStatus } from '@/hooks/useNetworkStatus';

/**
 * Persistent banner shown when the device has no network connection.
 * Sits above the global content (z-index above status bar overlay) so users
 * understand why fetches are failing. Hides itself the moment connectivity
 * returns — there's no manual dismiss.
 */
export default function OfflineBanner() {
    const online = useNetworkStatus();
    if (online) return null;
    return (
        <div
            role="status"
            aria-live="polite"
            className="fixed left-0 right-0 z-[2000] bg-red-600 text-white text-center text-sm font-medium px-4 py-2"
            style={{ top: 'env(safe-area-inset-top)' }}
        >
            You're offline. Some features may not work until you reconnect.
        </div>
    );
}
